import React from 'react';
import { Form, Button } from 'antd';

export default class SaveButton extends React.Component {
	render() {
		return (
			<Form.Item style={(this.props.style != null)? this.props.style: {textAlign:'right'}} {...this.props.formItemLayout}>
				<Button
					type="primary"
					htmlType="submit"
					icon="save"
					loading={this.props.loading}
					disabled={this.props.disabled}>
					{this.props.buttonText || 'Save'}
				</Button>
			</Form.Item>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/SaveButton/index.jsx